import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'antd';
import React from 'react';
import type { TFunction } from 'i18next';

type Props = {
  restart: () => void;
  t: TFunction;
};
const restartImportModal = ({ restart, t }: Props) =>
  Modal.confirm({
    title: t('Are you sure?'),
    icon: (
      <span className="anticon">
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          color="#fd9644"
          size="sm"
        />
      </span>
    ),
    content: t(
      'Are you sure you want to cancel? This will reset the import process and go back to the first step.'
    ),
    onOk: restart,
    okText: t('Restart import'),
    cancelText: t('Continue'),
    closable: true,
    maskClosable: true,
  });
export default restartImportModal;
